<template>
  <div class="column">
    <header
      class="row justify-between no-wrap items-center q-px-lg"
      style="height: 36px"
    >
      <div
        class="tlqn-admin-ml-edit-btn bg-white"
        v-if="!editMode && filteredSamples.length"
        @click="beforeEdit()"
      >
        <q-icon name="fas fa-check-circle" size="12px" class="q-mr-sm" />
        <span>移除样本</span>
      </div>

      <div class="row items-center" v-else-if="filteredSamples.length">
        <div class="row items-center">
          <div
            class="tlqn-admin-ml-edit-btn bg-white row items-center justify-center"
            style="width: 36px;height: 36px;"
            :class="{
              'tlqn-admin-ml-edit-btn-disable':
                prepareToBeRemovedSamples.length === 0,
            }"
            @click="
              prepareToBeRemovedSamples.length ? removeGroupSamples() : ''
            "
          >
            <q-icon name="fas fa-trash" size="14px" color="red" />
          </div>
          <span class="text-caption q-ml-xs">
            从分组中删除选中的样本
          </span>
        </div>
        <div class="row items-center q-ml-lg">
          <div
            class="tlqn-admin-ml-edit-btn bg-white row items-center justify-center"
            style="width: 36px;height: 36px;"
            @click="cancelEdit"
          >
            <q-icon name="fas fa-times-circle" size="14px" color="green" />
          </div>
          <span class="text-caption q-ml-xs">取消</span>
        </div>
      </div>
      <div v-else></div>

      <div class="row items-center" v-if="!editMode">
        <q-input filled dense label="输入以搜索样本" v-model="searchKeyword">
          <template v-slot:append>
            <q-icon size="12px" name="fas fa-search" />
          </template>
        </q-input>
      </div>
    </header>

    <div class="text-caption text-grey q-ml-lg q-mt-sm">
      当前共有
      <span class="text-primary">{{ filteredSamples.length }}</span>
      个样本
    </div>

    <q-scroll-area
      v-if="filteredSamples && filteredSamples.length"
      class="column col-grow q-my-md"
      id="_virtual_scroll"
    >
      <q-virtual-scroll
        scroll-target="#scroll-area-with-virtual-scroll-1 > .scroll"
        :items="filteredSamples"
        :virtual-scroll-item-size="filteredSamples.length"
        class="q-px-md q-py-lg"
        ref="virtualScroll"
        v-if="showVirtualScroll"
      >
        <template v-slot="{ item, index }">
          <q-item
            :to="{
              query: {
                ...$route.query,
                _gs: item.id,
              },
            }"
            :class="{
              'tlqn-admin-sample-group-spls-list-item-active':
                $route.query._gs === item.id,
            }"
            clickable
            :key="index"
            class="row no-wrap items-center tlqn-admin-sample-group-spls-list-item q-mb-sm"
          >
            <div
              class="tlqn-agmli-option q-pr-sm"
              :class="{
                'tlqn-agmli-option-show': editMode,
              }"
              :style="{
                transition: `all 0.3s ease`,
              }"
            >
              <q-checkbox v-model="prepareToBeRemovedSamples" :val="item.id" />
            </div>

            <!-- 基本信息 -->
            <div class="column no-wrap" style="width: 50%">
              <span
                class="text-bold q-mb-sm ellipsis"
                :title="item.detail.name"
              >
                <MatchHighlight
                  class-name="tlqn-ad-gmls-search-match"
                  :keyword="searchKeyword"
                  :text="item.detail.name"
                />
              </span>
              <span class="text-caption text-grey">
                样本id: {{ item.detail.sample_id }}
              </span>
            </div>

            <!-- 状态 -->
            <div class="row">
              <q-badge
                v-if="sampleStatusDict[item.sample_status]"
                :color="sampleStatusDict[item.sample_status].color"
              >
                {{ sampleStatusDict[item.sample_status].description }}
              </q-badge>
            </div>

            <div class="col-grow"></div>

            <!-- 查看或编辑 -->
            <div class="text-primary">
              <q-icon
                name="fas fa-edit"
                v-if="item.sample_status == 1"
                @click.prevent.stop="
                  prepareToBeMovedSample = item;
                  showMoveSampleDialog = true;
                "
              />
              <q-icon name="fas fa-eye" v-else />
            </div>

            <!-- |>|>|> -->
            <div style="width: 50px;" class="row justify-end">
              <q-icon
                :style="{
                  opacity: $route.query._gs === item.id ? 1 : 0,
                  visibility:
                    $route.query._gs === item.id ? 'visible' : 'hidden',
                }"
                class="tl-transition-1"
                name="fas fa-chevron-right"
                color="secondary"
                size="1.2rem"
              />
            </div>
          </q-item>
        </template>
      </q-virtual-scroll>
    </q-scroll-area>
    <main v-else class="column col-grow q-my-md justify-center items-center">
      <Empty text="请先添加成员" />
    </main>

    <footer class="row no-wrap justify-end items-center">
      <q-btn
        flat
        class="text-green bg-white shadow-22 q-mr-md"
        @click="showSampleOpreationDialog = true"
        :disable="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      >
        <q-icon name="fas fa-user-plus" size="12px" class="q-mr-sm" />
        <span>添加样本</span>
      </q-btn>
      <q-btn
        flat
        :disable="true"
        class="text-red bg-white shadow-22"
        @click="showRemoveGroupDialog = true"
      >
        <q-icon name="fas fa-trash" size="12px" class="q-mr-sm"></q-icon>
        <span>删除样本组</span>
      </q-btn>
    </footer>

    <!-- 删除分组对话框 -->
    <q-dialog v-model="showRemoveGroupDialog" persistent>
      <q-card class="q-pa-lg">
        <q-card-section class="row items-center text-red-5 text-bold">
          <q-icon
            name="fas fa-exclamation-triangle"
            size="30px"
            class="q-mr-xl"
          />
          <span>确定要删除当前样本组吗？删除后无法恢复，请谨慎操作！</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="取消"
            color="primary"
            v-close-popup
            :disable="removingGroup"
          />
          <q-btn
            flat
            label="确认删除"
            class="bg-red text-white"
            @click="deleteGroup"
            :loading="removingGroup"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- 添加样本对话框 -->
    <q-dialog v-model="showSampleOpreationDialog" persistent>
      <SampleOpreation
        @cancel="showSampleOpreationDialog = false"
        @updated="onGroupSampleUpdated"
        :group-id="groupId"
      />
    </q-dialog>

    <!-- 移动至其他样本组对话框 -->
    <q-dialog v-model="showMoveSampleDialog" persistent>
      <MoveToOtherGroup
        :groupId="groupId"
        :sample="prepareToBeMovedSample"
        @cancel="showMoveSampleDialog = false"
        @updated="afterMoveSample"
      />
    </q-dialog>
  </div>
</template>

<script>
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import { updateSampleGroupSamples } from "@/api/endpoints/sample-group/updateSampleGroupSamples";
import { deleteSampleGroup } from "@/api/endpoints/sample-group/deleteSampleGroup";
import { Prop } from "vue-property-decorator";
import SampleStatusMixin from "@/mixins/sample-status.mixin";
import { styleLog } from "../../../../utils/style-log";
import { setTimeout } from "timers";
export default {
  mixins: [AdminCommonStatus, SampleStatusMixin],
  components: {
    Empty: () => import("@/components/Empty"),
    SampleOpreation: () => import("./SampleOpreation"),
    MoveToOtherGroup: () => import("./MoveToOtherGroup"),
    MatchHighlight: () => import("@/components/MatchHighlight"),
  },
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
    groupId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showSampleOpreationDialog: false,
      showRemoveGroupDialog: false,
      // editMode: false,

      prepareToBeRemovedSamples: [],
      REMOVING_GROUP_MEMBERS,
      removingGroup: false,

      prepareToBeMovedSample: null,
      showMoveSampleDialog: false,
      showVirtualScroll: true,

      searchKeyword: "",
    };
  },

  watch: {
    "$route.query._gs": {
      immediate: true,
      handler(sampleId) {
        if (!sampleId) return;
        this.showVirtualScroll = false;
        let i = 0;
        for (; i < this.samples.length; i++) {
          if (this.samples[i].id === sampleId) break;
        }
        setTimeout(() => {
          this.showVirtualScroll = true;
          this.$nextTick(() => {
            try {
              this.$refs.virtualScroll.scrollTo(i);
            } catch (err) {
              console.log(err);
            }
          });
        }, 100);
      },
    },
  },

  computed: {
    editMode() {
      return this.adminStatusStore[REMOVING_GROUP_MEMBERS];
    },

    filteredSamples() {
      const samples = this.samples || [];
      const { searchKeyword } = this;
      if (!searchKeyword) return samples;
      return samples.filter((sample) => {
        return (
          sample &&
          sample.detail &&
          ((sample.detail.name || "").indexOf(searchKeyword) > -1 ||
            (sample.detail.sample_id || "").indexOf(searchKeyword) > -1)
        );
      });
    },
  },

  methods: {
    onGroupSampleUpdated() {
      this.$emit("updated");
      this.showSampleOpreationDialog = false;
    },

    cancelEdit() {
      this.prepareToBeRemovedSamples = [];
      this.updateAdminCommonStatus(REMOVING_GROUP_MEMBERS, false);
    },

    beforeEdit() {
      this.updateAdminCommonStatus(REMOVING_GROUP_MEMBERS, true);
    },

    /**
     * 移除选中的样本
     */
    async removeGroupSamples() {
      const { prepareToBeRemovedSamples } = this;
      try {
        const response = await updateSampleGroupSamples(this.groupId, {
          remove: prepareToBeRemovedSamples,
        });
        if (response.status && response.status != 1) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已移除",
          });
          this.$emit("updated");
          this.cancelEdit();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "移除样本时发生未知错误",
        });
      }
    },

    /**
     * 删除当前分组
     */
    async deleteGroup() {
      this.removingGroup = true;
      try {
        const response = await deleteSampleGroup(this.groupId);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已删除",
          });
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "删除样本组时发生未知错误",
        });
      } finally {
        this.removingGroup = false;
        this.$emit("deleted");
        this.showRemoveGroupDialog = false;
      }
    },

    /**
     * 处理移动样本完成
     */
    afterMoveSample() {
      this.showMoveSampleDialog = false;
      // 重新获取样本组详情
      this.$emit("updated");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
@import "@/styles/animate";

.tlqn-admin-ml-edit-btn {
  /* box-shadow: $shadow-1; */
  border-radius: 10px;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    box-shadow: $shadow-22;
  }
}
.tlqn-admin-ml-edit-btn-disable {
  cursor: not-allowed;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
    left: 0;
    top: 0;
  }
}

.tlqn-admin-sample-group-spls-list-item {
  overflow: hidden;
  height: 70px;
  border-radius: 2 * $generic-border-radius !important;
  color: unset !important;

  &.tlqn-admin-sample-group-spls-list-item-active {
    background-color: #fff;
    box-shadow: $shadow-22;
  }
}

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}
.tlqn-agmli-option {
  width: 50px;
  margin-left: -50px;
  visibility: hidden;
  flex-shrink: 0;
  &.tlqn-agmli-option-show {
    margin-left: 0;
    visibility: visible;
  }
}

.tlqn-agmli-info-progress {
  .tlqn-agmli-info {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .tlqn-agmli-progress {
    font-size: 0.75rem;
    color: $grey-8;
  }
  .tlqn-agmli-progress-wrapper {
    width: 100%;
    height: 8px;
    background-color: $tailong-purple;
    border-radius: 8px;
    overflow: hidden;
  }
  .tlqn-agmli-progress-block {
    width: 0;
    height: inherit;
    border-radius: inherit;
    background-color: $secondary;
    box-shadow: inset 0px 4px 4px rgba(255, 255, 255, 0.3),
      inset 0px -4px 4px rgba(0, 0, 0, 0.2);
  }
}
</style>
